import { thumbRoundSize } from './utils';

export class VideoItem {
    private readonly img: HTMLImageElement | null = null;

    constructor(img?: HTMLImageElement) {
        this.img = img || null;
    }

    getThumbRegex(): RegExp {
        return new RegExp('w:[0-9]+');
    }

    getImageSrc(): string {
        return this.img?.getAttribute('src') || '';
    }

    getNewWidth(): number {
        return this.img ? thumbRoundSize(this.img.offsetWidth) : 0;
    }

    replaceImageSrc(src: string, width: number): string {
        return src.replace(this.getThumbRegex(), `w:${width}`);
    }

    changeImageSrc(): void {
        if (!this.img) return;

        const src = this.getImageSrc();
        if (!src) return;

        const width = this.getNewWidth();
        this.img.src = this.replaceImageSrc(src, width);
    }
}

export function videoItemFactory(): any {
    return {
        img: null as HTMLImageElement | null,
        instance: null as VideoItem | null,

        init() {
            this.instance = new VideoItem(this.$refs.thumbnail);
        },

        changeImageSrc() {
            this.instance.changeImageSrc();
        },
    };
}
